import React, { useState } from 'react';
import { Form, Button, Card, Container, Alert, Col, Row, Modal } from 'react-bootstrap';
import { firestore } from "../../firebase";
import { useHistory } from 'react-router-dom';

export default function CreateCustomer() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showAlert, setShowAlert] = useState("");
    const [nombre, setNombre] = useState("");
    const [correo, setCorreo] = useState("");
    const [telefono, setTelefono] = useState("");
    const [direccion, setDireccion] = useState("");
    const [notas, setNotas] = useState("");
    const history = useHistory();

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        setError("");

        if (!nombre || !correo || !telefono || !direccion) {
            setError("Uno o más campos requeridos no llenados");
            setLoading(false);
            return null;
        }

        const createNombre = nombre.trim();
        const createCorreo = correo.trim();
        const createTelefono = telefono.trim();
        const createDireccion = direccion.trim();
        const createNotas = notas.trim();

        setNombre(createNombre);
        setCorreo(createCorreo);
        setTelefono(createTelefono);
        setDireccion(createDireccion);
        setNotas(createNotas);

        const newCliente = {
            nombre: createNombre,
            correo: createCorreo,
            telefono: createTelefono,
            direccion: createDireccion, 
            notas: createNotas,
            keywords: []
        }

        firestore.collection('clientes').add(newCliente)
        .then(() => {
            setShowAlert(true);
            setLoading(false);
        })
        .catch(() => {
            setError('Ocurrió un error inesperado, vuélvalo a intentar más tarde');
            setLoading(false);
        })
    }

    function handleClose() {
        setShowAlert(false);
        history.push("/customers");
    }

    return (
        <Container 
        className="d-flex align-items-center justify-content-center"
        >
            <div className="w-100" style = {{ maxWidth: "500px"}}>
                <h2 className="text-center mt-3 mb-4">Crear Cliente</h2>
                <Modal show={showAlert} onHide={handleClose}>
                    <Modal.Header>
                        <Modal.Title>Éxito</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Se creó el cliente correctamente
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleClose}>
                            Regresar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Card>
                    <Card.Body>
                        {error && <Alert variant="danger">{error}</Alert>}
                        <Form onSubmit={handleSubmit}>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="cliente-nombre">
                                    <Form.Label>Nombre</Form.Label>
                                    <Form.Control 
                                    type="text" 
                                    value={nombre}
                                    onChange={e => setNombre(e.target.value)}
                                    disabled={loading}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="cliente-correo">
                                    <Form.Label>E-mail</Form.Label>
                                    <Form.Control 
                                    type="email" 
                                    value={correo}
                                    onChange={e => setCorreo(e.target.value)}
                                    disabled={loading}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="cliente-telefono">
                                    <Form.Label>Número de teléfono</Form.Label>
                                    <Form.Control 
                                    type="tel" 
                                    value={telefono}
                                    onChange={e => setTelefono(e.target.value)}
                                    disabled={loading}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="cliente-direccion">
                                    <Form.Label>Dirección</Form.Label>
                                    <Form.Control 
                                    as="textarea" rows={2}
                                    value={direccion}
                                    onChange={e => setDireccion(e.target.value)}
                                    disabled={loading}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="cliente-notas">
                                    <Form.Label>Notas (opcional)</Form.Label>
                                    <Form.Control 
                                    as="textarea" rows={3}
                                    value={notas}
                                    onChange={e => setNotas(e.target.value)}
                                    disabled={loading}/>
                                </Form.Group>
                            </Row>
                            <Row className='m-2'>
                                <Col xs={3}>
                                    <Button disabled={loading} type="submit">Confirmar</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </Container>
    )
}